export default __webpack_public_path__ + "static/media/grand_palais_landscape.9a77a1d3.jpg";